import script from "./OAuthKakaoPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OAuthKakaoPage.vue?vue&type=script&setup=true&lang=ts"

import "./OAuthKakaoPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__